import React from 'react';
import Search from '../../Search';
import './SelectListSearch.scss';
function SelectListSearch(_a) {
    var onChange = _a.onChange;
    return (React.createElement("div", { className: "elmo-select-list__search" },
        React.createElement(Search, { isVisible: true, onChange: onChange })));
}
export default SelectListSearch;
